import React from 'react';

import AlertCautionIcon from '@/components/icons/AlertCaution.svg';
import AlertInformationIcon from '@/components/icons/AlertInformation.svg';

import { IParkAlert } from '../templates/ParkTemplate';
import css from './Alerts.module.css';

const getIcon = (type: string) => {
  return (
    <React.Fragment>
      {type == 'Information' && <AlertInformationIcon className="blue" />}
      {type == 'Caution' && <AlertCautionIcon className="red" />}
      {type == 'Danger' && <AlertCautionIcon className="red" />}
      {type == 'Park Closure' && <AlertCautionIcon className="red" />}
    </React.Fragment>
  );
};

interface IProps {
  id?: string;
  parkCode: string;
  alerts: IParkAlert[];
}

const Alerts: React.FC<IProps> = props => {
  const alerts = props.alerts ? props.alerts : [];

  if (alerts.length === 0) {
    return null;
  }

  return (
    <section id={props.id}>
      <h2 className="mb-2 highlight autoType800">Park Alerts ({alerts.length})</h2>
      <div className={css.alerts}>
        {alerts.map(alert => (
          <article className={css.alert} key={alert.id}>
            <h4>
              <span className={css.icon}>{getIcon(alert.category)}</span>
              <span>{`[${alert.category}] ${alert.title}`}</span>
            </h4>
            <div className={css.alertContent}>
              <p>{alert.description}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};
export default Alerts;
